import React, { Component } from 'react';
import './styles.css';

class GreyCentralCircle extends Component {
	render() {
		return (
			<div className="submission-stepper-item-layout-orange-central-circle">
				{this.props.children}
			</div>
		);
	}
}

export default GreyCentralCircle;
